import { useEffect } from 'react';
import { Button } from '../../components/ui/Button';

interface OrderSuccessScreenProps {
  orderId: number;
  whatsAppUrl: string;
  onBackToStore: () => void;
}

export function OrderSuccessScreen({ orderId, whatsAppUrl, onBackToStore }: OrderSuccessScreenProps) {
  useEffect(() => {
    window.open(whatsAppUrl, '_blank');
  }, [whatsAppUrl]);

  return (
    <div className="max-w-2xl mx-auto px-4 py-8">
      <div className="bg-white rounded-2xl shadow-sm p-6 sm:p-8 text-center flex flex-col items-center">
        <div className="w-16 h-16 rounded-full bg-olivine/10 flex items-center justify-center mb-4">
          <svg className="w-8 h-8 text-olivine" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
          </svg>
        </div>

        <h1 className="text-xl font-bold text-text-dark mb-1">
          Pedido nº {orderId} registrado com sucesso!
        </h1>
        <p className="text-sm text-text-medium mb-6 max-w-sm">
          Falta só um passo: envie o resumo do pedido para a vendedora no WhatsApp para confirmar o pagamento e a entrega.
        </p>

        <Button onClick={() => window.open(whatsAppUrl, '_blank')} size="lg" className="w-full sm:w-auto px-8 mb-3">
          <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
            <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347z" />
            <path d="M12 0C5.373 0 0 5.373 0 12c0 2.127.558 4.122 1.533 5.85L.057 23.535a.75.75 0 0 0 .916.928l5.803-1.524A11.938 11.938 0 0 0 12 24c6.627 0 12-5.373 12-12S18.627 0 12 0zm0 22c-1.853 0-3.587-.5-5.084-1.375l-.361-.214-3.742.981.998-3.648-.235-.374A9.963 9.963 0 0 1 2 12C2 6.477 6.477 2 12 2s10 4.477 10 10-4.477 10-10 10z" />
          </svg>
          Enviar pedido no WhatsApp
        </Button>

        <p className="text-xs text-text-light mb-4">
          Se o WhatsApp não abriu automaticamente, use o botão acima.
        </p>

        <button
          onClick={onBackToStore}
          className="text-sm font-medium text-text-medium hover:text-chocolate underline transition-colors"
        >
          Voltar para a loja
        </button>
      </div>
    </div>
  );
}
